import { useEffect, useRef, useState } from "react";

interface TDDSectionProps {
  title: string;
  children: React.ReactNode;
}

export function TDDSection({ title, children }: TDDSectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="space-y-6">
      {/* Section heading - reduced opacity */}
      <h3 
        className={`font-mono text-[13px] uppercase tracking-[0.18em] text-white/45 transition-all duration-[180ms] ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[4px]"
        }`}
        style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        }}
      >
        {title}
      </h3>
      
      {/* Content - increased line-height, consistent spacing */}
      <div 
        className={`text-white/70 leading-relaxed sm:leading-[1.7] text-sm sm:text-[15px] transition-all duration-[240ms] ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[4px]"
        }`}
        style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          transitionDelay: "60ms",
        }}
      >
        {children}
      </div>
    </div>
  );
}

